// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"2555fa7e","38":"078362d7","195":"0bb11564","319":"649e6f7f","347":"7b23b7e6","401":"4229e533","410":"d6d0d111","453":"d9e3feb1","531":"80c2e7db","590":"e440a467","708":"8a1f123c","729":"7f08780c","776":"5e82e215","892":"f90a70e0","940":"d6df8b54"}[chunkId] + ".chunk.js";
};